module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SuperHeavy.dea6306.woff2";